/**
 * Response statuses this layer and its callers agree on the meaning of.
 *
 * Nothing game-shaped belongs here, and nothing here belongs in
 * `~/lib/constants` — that file is the game's own vocabulary (levels, turn
 * phases, modals), and an HTTP status is not part of it.
 *
 * 401 is deliberately not here. The interceptor owns it outright:
 * `handleUnauthorized` clears the session and sends the player to `/login`.
 */

/**
 * The save is not this player's. The backend returns it for nothing else, and
 * the interceptor answers it from any request: the playthrough goes and the
 * player is sent to character select.
 */
export const FORBIDDEN = 403;

/**
 * The thing asked for does not exist. From the load, that is a save that is
 * gone, and `~/store/game/actions` lets it go; the load claims it with
 * `isNotFoundHandledByCaller` so the interceptor stays quiet. From anything
 * else it is a request the backend does not know, and gets the network error
 * modal.
 */
export const NOT_FOUND = 404;
